<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="costCenter in costCenters">
                    <td>
                        <input type="text" v-if="costCenter.editable" class="form-control" :name="costCenter.value" v-model="form['value'][costCenter.id]">
                        <span v-if="!costCenter.editable">{{ costCenter.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeBlikOpWerk(costCenter)" class="btn btn-danger" v-if="costCenter.deleteable" :title="uLang('app.delete_document_type')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newCostCenter" placeholder="Type hier uw kostenplaats type" title="Voeg nieuwe kostenplaats toe">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addCostCenter" :disabled="form.busy || ! newCostCenter">{{ uLang('app.add_type', {type: lang('app.cost_center')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'form-setting-blik-op-werk',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newCostCenter: '',
                costCenters: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.type_successfully_updated', {type: lang('app.cost_center')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.costCenters = data;

                data.forEach(function (costCenter){
                    if(costCenter.editable){
                        this.value[costCenter.id] = costCenter.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addCostCenter() {
                if (this.newCostCenter === '')
                    return;

                this.costCenters.push(
                    {
                        id: this.newCostCenter,
                        value: this.newCostCenter,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newCostCenter] = this.newCostCenter;
                this.newCostCenter = '';
            },

            removeBlikOpWerk(BlikOpWerk) {
                new DestroyAlert({ entity: this.lang('app.cost_center') }).show().then(async () => {
                    delete this.form.value[BlikOpWerk.id];

                    this.costCenters = this.costCenters.filter(function (currentCostCenter) {
                        return currentCostCenter.value != BlikOpWerk.value;
                    });
                });
            }
        }
    }
</script>

<style lang="css" scoped>

</style>